<template xmlns:v-lazy="http://www.w3.org/1999/xhtml">
  <div class="detail">
    <app-header logo-link="/rent/listing" page="rentDetail" />

    <div class="detail-container">
      <section class="section-detail-top">
        <div class="detail-top--left">
          <div class="detail-top--left--inner">
            <div class="info">
              <span
                v-if="info.rentType"
                class="line capitalize"
              >{{ $t('rentType.' + info.rentType) }}</span>
              <span v-if="info.renewalAt">{{ getRenewalAt }}</span>
            </div>
            <h1>{{ info.title }}</h1>
            <div class="rooms">
              <span v-if="info.houseTypeArray && info.houseTypeArray[0]" class="capitalize">
                {{
                info.houseTypeArray[0] + ' Beds'
                }}
              </span>
              <span v-if="info.houseTypeArray && info.houseTypeArray[1]" class="capitalize">
                {{
                info.houseTypeArray[1] + ' Baths'
                }}
              </span>
              <span
                v-if="info && info.sqft"
                class="capitalize"
              >{{ $formatMoney(info.sqft) + ' Sq.Ft' }}</span>
            </div>
            <p class="desc">{{ info.subTitle }}</p>
          </div>
        </div>
        <div class="detail-top--right">
          <vue-agile
            v-if="info.coverGallery"
            class="cover-agile"
            :autoplay="true"
            :dots="false"
            :infinite="true"
            :fade="true"
            :autoplay-speed="5000"
            :nav-buttons="false"
          >
            <div
              v-for="item of info.coverGallery"
              :key="item.url"
              class="cover-agile-item"
              :style="'background-image:url(' + $processImage(item.url, { resize: 'lg' }) + ')'"
            ></div>
          </vue-agile>
        </div>
      </section>
      <FixedAgentCard
        v-if="agentInfo"
        :info="agentInfo"
        :lang="currentApiLang"
        @showDrawer="showDrawer"
      ></FixedAgentCard>
      <ValidatePasswd
        v-if="needPasswd"
        :lang="currentApiLang"
        type="rental"
        @validated="handleDetailRes"
      ></ValidatePasswd>
      <!-- <div class="detail-main"> -->
      <section v-if="info.detail && !needPasswd" class="section-detail">
        <div v-if="info && info.feature && info.feature.length" class="features">
          <div class="title">FEATURES</div>
          <div class="feature-list">
            <div
              v-for="feature in info.feature"
              :key="feature.id"
              class="feature-item"
            >{{ feature.name[currentApiLang] }}</div>
          </div>
        </div>
        <SlideGallery v-if="docGallery.length" :images="docGallery"></SlideGallery>
        <!-- <div class="imgs" v-if="docGallery && docGallery.length">
            <div class="img-container" v-if="sliders1_big_img">
              <img v-lazy="$processImage(sliders1_big_img.url,{resize:'mid'})" :alt="sliders1_big_img.name" @click="viewAlbum(docGallery)" />
              <div class="img-desc">
                <p>{{ sliders1_big_img.name }}</p>
                <p>{{ $t(sliders1_big_img.desp) }}</p>
              </div>
              <div v-if="sliders1_current_index !== 0" class="img-slide-nav nav-prev" @click="() => this.$refs.imgSlider1.slidePrev()">
                <font-icon id="left"></font-icon>
              </div>
              <div v-if="sliders1_current_index !== docGallery.length - 1" class="img-slide-nav nav-next" @click="() => this.$refs.imgSlider1.slideNext()">
                <font-icon id="right"></font-icon>
              </div>
            </div>
            <ImgSlide ref="imgSlider1" :imgs="docGallery" @slide="onImgSlide" />
        </div>-->
        <div v-if="description" class="desc-wrap clearfix">
          <div class="title">Description</div>
          <div
            class="desc"
            :class="{ showAll: isShowAll }"
            v-html="decodeURIComponent(description)"
          ></div>
        </div>
        <div v-if="getYoutubeId" class="video">
          <div class="title">Video</div>
          <div class="youtube">
            <youtube ref="youtube" :video-id="getYoutubeId" width="566" height="289" :resize="true"></youtube>
          </div>
        </div>
        <div class="geo">
          <div class="geo-title">
            <!-- <span class="strong-text fs16">{{ $t('location') }}</span> -->
            <span v-if="info.geoInfo">
              {{ info.geoInfo.city.length ? (info.geoInfo.city[0].name || {})[currentApiLang] : '' }}
              {{ info.geoInfo.district.length ? (info.geoInfo.district[0].name || {})[currentApiLang] : '' }}
              {{ info.geoInfo.zip }}
            </span>
          </div>
          <div v-if="info.geoInfo" class="geo-map">
            <!-- test center: { lat: 29.5705292, lng: 106.4609418 } -->
            <GmapMap
              v-if="!isChina"
              class="geo-map-instance"
              :center="info.geoInfo.latlng"
              :zoom="mapZoom"
              :options="GmapOptions"
              map-type-id="terrain"
            >
              <Gmap-marker :position="info.geoInfo.latlng" :icon="mapMarkerIcon"></Gmap-marker>
            </GmapMap>
            <BaiduMap
              v-else
              class="geo-map-instance"
              ak="eqcYd7HeRK04gMuOIpqYTegkWfw9Oda6"
              :center="info.geoInfo.latlng"
              :zoom="15"
              :scroll-wheel-zoom="true"
            >
              <BmMaker :position="info.geoInfo.latlng" :dragging="true"></BmMaker>
            </BaiduMap>
          </div>
          <div v-if="isManual" class="geo-desc">
            <p
              v-for="(nearbyInfo, nearbyIndex) in nearbyInfoList"
              :key="'nearbyInfo-' + nearbyIndex"
            >
              <span class="strong-text">{{ (nearbyInfo.name || {})[currentApiLang] }}</span>
              <span class="fs13">{{ nearbyInfo.time }}{{ nearbyInfo.distance }}</span>
            </p>
          </div>
          <div v-if="!isManual && nearbyList !== null" class="geo--nearby--box">
            <div class="geo--nearby--box--head">
              <div
                v-for="(nearbyItem, nearbyIndex) in typeList"
                :key="nearbyIndex"
                class="geo--nearby--box--head--item"
                :class="{ 'geo--nearby--box--head--active': activeIndex === nearbyIndex }"
                @click="changeType(nearbyIndex)"
              >{{ nearbyItem }}</div>
            </div>
            <div v-loading="nearbyLoading" class="pointer-list">
              <div
                v-for="(pointer, pointerIndex) in nearbyList"
                :key="pointerIndex"
                class="pointer-item"
                @click="pointerClick(pointer)"
              >
                <div class="pointer-item-left">
                  {{ pointer.name }}
                  <div
                    v-if="pointer.rating"
                    class="pointer-item-left-rate"
                  >{{ pointer.rating.toFixed(1) }}</div>
                </div>
                <div class="pointer-item-right">{{ pointer.distance }} miles</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="info.buildingFacility && info.buildingFacility.length" class="public">
          <div class="public-title fs16">{{ $t('insideFacility') }}</div>
          <div class="public-items">
            <ul>
              <li v-for="insFac in info.buildingFacility" :key="'build-' + insFac.id">
                <div>
                  <font-icon :id="insFac.icon"></font-icon>
                  {{ (insFac.name || {})[currentApiLang] }}
                </div>
              </li>
              <li v-for="insFac in info.insideFacility" :key="'inside-' + insFac.id">
                <div>
                  <font-icon :id="insFac.icon"></font-icon>
                  {{ (insFac.name || {})[currentApiLang] }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="more-info">
          <div class="section-title fs16">{{ $t('moreInfo') }}</div>
          <div v-if="info.detail" class="more-info-items">
            <label v-if="info.detail.builtYear">
              <span>{{ $t('builtYear') }}:</span>
              {{ info.detail.builtYear }}
            </label>
            <label v-if="info.detail.decoration">
              <span>{{ $t('decoration') }}:</span>
              {{ $t('decorationStyle.' + info.detail.decoration.toString()) }}
            </label>
            <label v-if="info.detail.gender">
              <span>Gender Preference:</span>
              {{ info.detail.gender.toString() === 'none' ? 'Any' : info.detail.gender.toString() }}
            </label>
            <label v-if="info.detail.orientation.length">
              <span>{{ $t('orientation') }}:</span>
              <span
                v-for="(orientation, i) in info.detail.orientation"
                :key="'orientation-' + i"
                class="more-info-items--option"
              >{{ $t(orientation.toString()) }}</span>
            </label>
            <label>
              <span>{{ $t('allowCooking') }}:</span>
              {{ $t(info.detail.allowCooking ? 'allow' : 'notAllow') }}
            </label>
            <label v-if="info.detail.bondsman">
              <span>{{ $t('bondsman') }}:</span>
              {{ $t(info.detail.bondsman ? 'need' : 'notNeed') }}
            </label>
            <label v-if="info.detail.floorType">
              <span>{{ $t('floorType') }}:</span>
              {{ $t(info.detail.floorType.toString()) }}
            </label>
            <label v-if="info.detail.elevator">
              <span>{{ $t('elevator') }}:</span>
              {{ $t(info.detail.elevator ? 'exsit' : 'notExist') }}
            </label>
            <label v-if="info.detail.maxLiving">
              <span>{{ $t('maxLiving') }}:</span>
              {{ info.detail.maxLiving }}
            </label>
            <label v-if="info.detail.tenancyTerm.length">
              <span>{{ $t('minTenancyTerm') }}:</span>
              {{ info.detail.tenancyTerm }}
            </label>
            <label v-if="info.detail.avl">
              <span>{{ $t('availableTime') }}:</span>
              {{ info.detail.avl && info.detail.avl.slice(0, 10) }}
            </label>
            <label v-else>
              <span>{{ $t('availableTime') }}:</span>
              {{ $t('anytime') }}
            </label>
            <label>
              <span>{{ $t('propertyType') }}:</span>
              {{ info.detail.propertyType }}
            </label>
            <label>
              <span>{{ $t('allowParty') }}:</span>
              {{ $t(info.detail.allowParty ? 'allow' : 'notAllow') }}
            </label>
            <label>
              <span>{{ $t('allowSmoking') }}:</span>
              {{ $t(info.detail.allowSmoking ? 'allow' : 'notAllow') }}
            </label>
            <label>
              <span>{{ $t('allowPet') }}:</span>
              {{ $t('pets.' + info.detail.allowPet) }}
            </label>
          </div>
        </div>
        <!-- 评分 -->
        <div class="rate">
          <div class="rate-rated">
            <div v-if="info.selfRate && info.selfRate.length" class="rate-agent">
              <div class="rate-rated-title">{{ $t('agentRate') }}</div>
              <app-rating
                v-for="(r, i) in info.selfRate"
                :key="'selfRate-' + i"
                class="rating-item"
                :number="r.star"
                :disabled="true"
              >
                <span class="rating-item--text color-black">{{ r.text }}</span>
              </app-rating>
            </div>
            <div v-if="info.rateHistory" class="rate-user">
              <div class="rate-rated-title">{{ $t('userRate') }}</div>
              <app-rating class="rating-item" :number="info.rateHistory.rate || 0" :disabled="true">
                <span
                  class="color-gray"
                >{{ info.rateHistory.rate || 0 }} / {{ info.rateHistory.count }} {{ $t('rates') }}</span>
              </app-rating>
            </div>
          </div>
          <div class="rate-action">
            <app-rating
              class="rating-item"
              :number="getHistoryRate"
              :disabled="isHasRated"
              @change="currentRateChange"
            ></app-rating>
            <div
              v-if="showSubmitBtn"
              class="rating-btn"
              @click="updateRate(currentRate)"
            >{{ $t('submitRates') }}</div>
            <p v-else>{{ isHasRated ? $t('hasRated') : $t('whatThinkOf') }}</p>
          </div>
        </div>
        <!-- 评论 -->
        <detail-comment :house="info" :house-i-d="info.id"></detail-comment>
      </section>
      <section v-if="info.detail && !needPasswd" class="section-float">
        <FloatingPriceCard :info="info" :is-share-page="isSharePage" />
        <!-- <floating-price :info="info" /> -->
      </section>
      <!-- </div> -->
      <detail-date
        class="detail-date"
        :date-info="dateInfo"
        :house="info"
        :is-sell="false"
        :show-box="showDateBox"
        @closeDateBox="showDateBox = false"
      />
    </div>
    <app-footer />
  </div>
</template>
<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
// import ImgSlide from '@/components/rentdetail/ImgSlide.vue'
import AppRating from '@/components/rentdetail/AppRating.vue'
import FloatingPriceCard from '@/components/rentdetail/FloatingPriceCard.vue'
import convertGalleryData from '@/common/convert-gallery-data'
import GmapStyles from 'map-style'
import CONFIG from '@/common/config'
import mapMarkerIcon from '@/assets/images/map-marker.png'
// eslint-disable-next-line
import DetailComment from '../components/DetailComment'
import DetailDate from '../components/DetailDate'
import getPassTime from '../common/get-pass-time'
import jstz from 'jstz'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmMaker from 'vue-baidu-map/components/overlays/Marker.vue'
import pointerClick from '@/common/pointerClick'
import getLinkInfo from '@/common/get-link-info'
// import Gallery from "vue-cover-gallery"
import { VueAgile } from 'vue-agile'
import SlideGallery from '@/components/SlideGallery'
import FixedAgentCard from '@/components/FixedAgentCard'
import ValidatePasswd from '@/components/ValidatePasswd.vue'
export default {
  components: {
    DetailDate,
    DetailComment,
    AppHeader,
    AppFooter,
    // ImgSlide,
    AppRating,
    FloatingPriceCard,
    BaiduMap,
    BmMaker,
    VueAgile,
    SlideGallery,
    FixedAgentCard,
    ValidatePasswd,
    // Gallery,
  },
  mixins: [pointerClick, getLinkInfo],
  data() {
    return {
      currentApiLang: 'en-US',
      houseID: this.$route.params.id,
      nearbyLoading: false,
      info: {},
      mapZoom: CONFIG.DEFAULT_MAP_ZOOM,
      GmapOptions: {
        styles: [
          ...GmapStyles.dark,
          {
            featureType: 'transit',
            stylers: [{ color: '#d59563', visibility: 'off' }],
          },
        ],
      },
      mapMarkerIcon,
      docGallery: [],
      sliders1_big_img: {},
      sliders1_current_index: 0,
      isFloating: false,
      hasRated: false,
      isShowAll: true,
      agentInfo: null,

      activeIndex: 0,
      typeList: ['School', 'Transportation', 'Restaurants', 'Shopping', 'Health', 'Facility'],
      nearbyList: [],
      activeImage: 0,
      currentRate: 0,
      showSubmitBtn: false,
      showDateBox: false,
      dateInfo: {},
      isChina: false,
      typeString: 'rental',
      nearbyInfoList: [],
      needPasswd: false,
      type: 'rental',
    }
  },
  computed: {
    description() {
      let description = this.info.description
      if (description) {
        return description.replace(
          '<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>',
          ''
        )
      }
      return description
    },
    isSharePage() {
      return !!this.agentName
    },
    isManual() {
      // true手动 false自动
      if (this.info && this.info.geoInfo && this.info.geoInfo.isManual) {
        return this.info.geoInfo.isManual
      }
      return false
    },
    primaryNearby() {
      const geoInfo = this.info.geoInfo
      if (!geoInfo || !geoInfo.nearby || !geoInfo.nearby.primary) return false

      const primary = geoInfo.nearby.primary
      return {
        name: primary.facility && primary.facility.name,
        distance: primary.distance,
        time: primary.time,
      }
    },
    getHistoryRate() {
      if (this.info.hasRated) {
        return this.info.ratedInfo.rate
      }
      return 0
    },
    isHasRated() {
      if (this.info && this.info.hasRated) {
        return this.info.hasRated
      }
      return this.hasRated
    },
    getYoutubeId() {
      if (this.info && this.info.youtube && this.info.youtube[0]) {
        return this.$youtube.getIdFromUrl(this.info.youtube[0].link)
      }
      return false
    },
    player() {
      return this.$refs.youtube.player
    },
    getRenewalAt() {
      if (this.info && this.info.renewalAt) {
        let passTime = getPassTime(this.info.renewalAt)
        if (this.$i18n.locale === 'en') {
          return 'Updated ' + passTime.num + ' ' + passTime.unit + ' ago'
        } else {
          return passTime.num + ' ' + this.$t(passTime.unit) + '前更新'
        }
      }
      return false
    },
  },
  watch: {
    '$store.state.apiLang': {
      immediate: true,
      handler(val) {
        this.currentApiLang = val
      },
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  created() {
    this.getInfo()
    const timezone = jstz.determine()
    if (timezone.name() === 'Asia/Shanghai') {
      this.isChina = true
    }
  },
  methods: {
    getDetailInfo() {
      this.$axios({
        url: '/api/v1/client/estate/rental/getRentalDetailByUniqueTitle/' + this.houseID,
        method: 'get',
      })
        .then((res) => {
          this.handleDetailRes(res)
        })
        .catch(() => {
          this.closeFullLoading()
          this.loading = false
        })
    },
    handleDetailRes(res) {
      this.closeFullLoading()
      this.info = res.doc
      this.agentInfo = res.doc.agent
      this.docGallery = convertGalleryData(res.doc)
      this.needPasswd = res.needPasswd
      if (res.needPasswd) return

      if (!this.info.geoInfo.isManual) {
        this.getNearbyInfo()
        this.changeType()
      }

      // this.sliders1_big_img = this.docGallery[this.sliders1_current_index]
    },
    getNearbyInfo() {
      if (!this.info.geoInfo) return
      const nearby = this.info.geoInfo.nearby
      const res = []
      Object.keys(nearby).forEach((name) => {
        if (Array.isArray(nearby[name])) {
          const itemList = nearby[name]
          itemList.forEach((item) => {
            if (item.id)
              res.push({
                id: item.id,
                name: (item.facility && item.facility.name) || {},
                distance: item.distance,
                time: item.time,
              })
          })
        }
      })
      return res
    },
    getInfo() {
      this.openFullLoading()
      // 分享页
      if (this.isSharePage) {
        this.getLinkInfo(this.type)
      } else {
        this.getDetailInfo()
      }
    },
    goSharePage() {
      const link = location.href
      location.href = link.replace('/detail', '')
    },
    openFullLoading() {
      this.loader = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },
    closeFullLoading() {
      this.loader.close()
    },
    // onImgSlide(obj) {
    //   this.sliders1_big_img = this.docGallery[obj.currentSlide]
    //   this.sliders1_current_index = obj.currentSlide
    // },
    currentRateChange(num) {
      this.currentRate = num
      this.showSubmitBtn = true
    },
    updateRate(num) {
      this.$axios({
        url: '/api/v1/client/estate/updateRate',
        method: 'post',
        data: { id: this.info.id, rate: num },
      })
        .then((res) => {
          console.log(res)
          this.hasRated = true
          this.showSubmitBtn = false
        })
        .catch(() => {
          this.closeFullLoading()
          this.loading = false
        })
    },
    getLangName(name) {
      if (name) {
        if (this.$i18n.locale === 'zh-CN' && name['zh-CN']) {
          return name['zh-CN']
        } else if (name['en-US']) {
          return name['en-US']
        }
      }
      return ''
    },
    viewOriginImage(url) {
      window.open(url)
    },
    changeType(index = 0) {
      this.nearbyList = []
      this.activeIndex = index
      let data = {
        lng: this.info.geoInfo.latlng.lng,
        lat: this.info.geoInfo.latlng.lat,
        type: this.typeList[index].toLowerCase(),
        language: 'en-US',
        distanceUnit: 'mile',
      }
      this.nearbyLoading = true
      this.$axios({
        url: 'https://map-api2.unicapsule.com/nearby',

        method: 'post',
        data: data,
      })
        .then((res) => {
          this.nearbyLoading = false
          if (res && res.results && res.results.length) {
            this.nearbyList = res.results
          }
        })
        .catch((err) => {
          console.log(err)
          this.nearbyLoading = false
          this.nearbyList = null
        })
    },
    // pointerClick(location) {
    //   let pointStr = '@' + location.lat + ',' + location.lng + ',' + this.mapZoom + 'z'
    //   window.open('https://www.google.com/maps/' + pointStr)
    // },
    // viewAlbum(images) {
    //   let _this = this
    //   let items = []
    //   images.forEach(image => {
    //     items.push({
    //       src: image.url,
    //       opts: {
    //         caption: image.name,
    //         thumb: image.url,
    //         height: window.innerHeight * 0.6,
    //         beforeClose: function(current) {
    //           _this.activeImage = current.currIndex
    //         },
    //       },
    //     })
    //   })
    //   $.fancybox.open(
    //     // items
    //     items,
    //     // options
    //     {
    //       loop: true,
    //       buttons: ['zoom', 'thumbs', 'close'],
    //     },
    //     _this.activeImage
    //   )
    // },
    showDrawer(info) {
      this.dateInfo = info
      this.showDateBox = true
    },
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop === 2090) {
        if (this.info.youtube[0].autostart) {
          this.player.playVideo()
        }
      }
    },
  },
}
</script>
<style lang="less">
/*全局样式*/
.detail-top--rating {
  .el-rate__text {
    margin-left: 32px;
  }
}
</style>
<style lang="less" scoped>
@import url('../assets/less/var.less');

@detail-top-content-height: 362px;

.fs13 {
  font-size: 13px;
}

.fs16 {
  font-size: 16px;
}

.color-gray {
  color: #898989;
}

.color-black {
  color: rgba(0, 0, 0, 0.85);
}

.cover-agile-item {
  height: 362px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.section-float {
  position: sticky;
  top: 160px;
  height: 96px;
  /* height 与 margin-top保持一致 */
  z-index: 1;
}

.section-detail-top {
  height: @detail-top-content-height;

  .detail-top--left {
    width: 290px;
    display: flex;
    align-items: center;
    padding: 22px;
    box-sizing: border-box;
    background: #f1f1f1;
    overflow-y: hidden;

    h1 {
      font-size: 18px;
      color: rgba(0, 0, 0, 0.8);
      line-height: 1.5;
      margin: 0 0 9px;
    }
  }

  .detail-top--right {
    flex: 1;
    overflow: hidden;
    margin-left: 7px;

    // .detail-top--right--img {
    //   vertical-align: middle;
    //   margin-left: 7px;
    //   position: relative;

    //   height: 100%;
    //   overflow: hidden;
    //   background-repeat: no-repeat;
    //   background-size: cover;
    // }

    .btns {
      position: absolute;
      right: 0;
      top: 15px;

      span {
        display: inline-block;
        width: 40px;
        height: 40px;
        background: #fff;
        border-radius: 8px;
        line-height: 40px;
        text-align: center;
        margin-right: 23px;
      }

      .icon {
        color: @theme-color;
        font-size: 18px;
      }
    }
  }

  .info {
    margin-bottom: 4px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);

    .line {
      height: 17px;
      line-height: 17px;
      display: inline-block;
      margin-right: 12px;
      padding-right: 8px;
      border-right: 1px solid rgba(151, 151, 151, 1);
    }
  }

  .info::before {
    content: none;
  }

  .rooms {
    margin: 12px 0;
    height: 14px;
    line-height: 14px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.85);

    > span {
      display: inline-block;
      margin-left: 12px;
      padding-right: 8px;
      border-right: 1px solid rgba(151, 151, 151, 1);

      &:first-child {
        margin-left: 0;
        padding-left: 0;
      }

      &:last-child {
        border: none;
      }
    }
  }

  .desc {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.85);
  }
}

.detail-main {
  .features {
    margin: 30px 0;

    .title {
      display: inline-block;
      width: 76px;
      height: 20px;
      font-size: 17px;
      color: rgba(0, 0, 0, 1);
      line-height: 22px;
    }

    .feature-list {
      display: inline-block;
      width: 490px;

      .feature-item {
        display: inline-block;
        margin-left: 56px;
        height: 14px;
        font-size: 12px;
        color: rgba(109, 114, 120, 1);
        line-height: 15px;
      }
    }
  }

  .geo-title,
  .section-title,
  .rooms-title,
  .public-title {
    color: rgba(0, 0, 0, 0.5);
  }

  .desc-wrap {
    position: relative;

    .title {
      display: inline-block;
      width: 130px;
      height: 20px;
      font-size: 17px;
      color: rgba(0, 0, 0, 1);
      line-height: 22px;
      vertical-align: top;
    }
  }

  .desc {
    margin-top: 20px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 2;
    padding: 57px 0;
    max-height: 80px;
    overflow-y: hidden;
  }

  .desc.showAll {
    max-height: none;
  }

  .show-all {
    position: absolute;
    bottom: 0;
    left: 0;
    background: #fff;
    color: #9ecf40;
    text-align: center;
    width: 100%;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
  }
}

.video {
  .title {
    margin-bottom: 34px;
    padding-top: 57px;
    width: 130px;
    height: 20px;
    font-size: 17px;
    color: rgba(0, 0, 0, 1);
    line-height: 22px;
    vertical-align: top;
  }
}

.geo {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  margin-top: 25px;
  margin-bottom: 57px;

  .geo-map {
    width: 100%;
    height: 353px;
    margin-bottom: 22px;
  }

  .geo-map-instance {
    width: 100%;
    height: 353px;
  }

  .geo-map-marker {
    width: 32px;
    height: 32px;
  }

  .strong-text {
    color: #000;
  }

  .geo-title {
    margin-bottom: 28px;

    span {
      margin-right: 28px;
    }
  }

  .geo-desc span {
    margin-right: 16px;
  }

  .geo--nearby--box {
    height: 270px;

    .geo--nearby--box--head {
      display: flex;
      height: 30px;
      line-height: 30px;
      border-bottom: 1px solid rgba(224, 224, 224, 0.5);

      .geo--nearby--box--head--item {
        display: inline-block;
        margin-right: 38px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.5);
        cursor: pointer;
      }

      .geo--nearby--box--head--active {
        color: rgba(0, 0, 0, 0.85);
      }
    }

    .pointer-list {
      width: 100%;
      height: 240px;
      overflow-y: auto;

      .pointer-item {
        display: flex;
        height: 40px;
        line-height: 40px;

        .pointer-item-left {
          display: inline-block;
          width: 80%;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .pointer-item-left-rate {
            display: inline-block;
            margin-left: 8px;
            width: 41px;
            height: 20px;
            line-height: 20px;
            background: rgba(153, 210, 13, 1);
            border-radius: 3px;
            font-size: 12px;
            color: rgba(255, 255, 255, 1);
            text-align: center;
          }
        }

        .pointer-item-right {
          display: inline-block;
          width: 20%;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.5);
        }
      }
    }

    ::-webkit-scrollbar {
      display: none;
    }
  }
}

.rooms {
  .rooms-title {
    margin-bottom: 12px;
  }

  // .room-desc {
  //   margin-top: 20px;
  // }
  // .room-desc-item {
  //   display: inline-block;
  //   width: 328px;
  //   box-sizing: border-box;
  //   margin-bottom: 34px;
  //   vertical-align: top;
  //   p {
  //     padding-left: 25px;
  //     line-height: 1;
  //     margin-bottom: 14px;
  //   }
  //   p:first-child {
  //     padding-left: 0;
  //   }
  //   .room-desc-item--title {
  //     display: inline-block;
  //     width: 90%;
  //     vertical-align: top;
  //     line-height: 1.3;
  //   }
  // }

  .room-list--item {
    margin-bottom: 10px;
  }

  .room-icon {
    color: #99d20d;
    margin-left: 19px;
  }

  .room-name,
  .room-size {
    margin-left: 19px;
  }

  .room-list-item-facility--list {
    display: flex;
    flex-wrap: wrap;
    padding: 0 20px;
    background-color: rgba(0, 0, 0, 0.1);

    .room-list-item-facility--item {
      margin-right: 20px;
      padding-bottom: 15px;

      .room-list-item-facility-item--icon {
        font-size: 22px;
        color: #000;
        vertical-align: middle;
      }

      .room-list-item-facility-item--name {
        padding-left: 15px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }
}

.public {
  margin-top: 45px;

  .public-items {
    margin-top: 16px;

    ul {
      margin: 0;
      list-style: none;
      padding: 0;

      li {
        position: relative;
        display: inline-block;
        width: 310px;
        margin-bottom: 14px;
      }
    }
  }
}

.more-info {
  margin-top: 57px;

  .more-info-items {
    margin-top: 20px;

    label {
      display: inline-block;
      width: 267px;
      margin-bottom: 13px;
      vertical-align: top;
      text-transform: capitalize;

      span {
        color: rgba(0, 0, 0, 0.5);
      }
    }

    label:nth-child(2n + 2) {
      width: 267px;
    }
  }

  .more-info-items--option {
    &::after {
      content: ',';
    }

    margin-right: 4px;
    color: #000 !important;
  }

  .more-info-items--option:last-child {
    &::after {
      display: none;
    }
  }
}

.rate {
  margin-top: 32px;
  padding: 13px 21px;
  box-sizing: border-box;
  border-radius: 8px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);

  .rate-agent {
    display: inline-block;
    margin-right: 20px;
    vertical-align: top;
    width: 280px;
  }

  .rate-user {
    display: inline-block;
    vertical-align: top;
    width: 220px;
  }

  .rate-rated-title {
    margin-bottom: 19px;
  }

  .rating-item {
    margin-bottom: 13px;

    .rating-item--text {
      display: inline-block;
      padding: 0 0 0 30px;
      width: 120px;
      vertical-align: text-top;
    }

    .color-gray {
      padding-left: 20px;
    }
  }

  .rate-action {
    text-align: center;
    margin-top: 28px;

    p {
      margin-top: 13px;
    }

    .rating-btn {
      margin: 20px auto;
      width: 119px;
      height: 38px;
      background: rgba(153, 210, 13, 1);
      border-radius: 5px;
      font-size: 14px;
      color: rgba(249, 249, 249, 1);
      text-align: center;
      line-height: 38px;
      cursor: pointer;
    }
  }
}

.detail-date {
  position: fixed;
  right: 50px;
  bottom: 0;
  z-index: 2000;
}

@media (max-width: 767px) {
  .cover-agile-item {
    height: 260px;
  }

  .section-detail-top {
    height: auto;
    display: flex;
    flex-direction: column-reverse;

    .detail-top--left {
      width: 100%;
      min-height: 0;
      display: block;
      padding: 16px;

      h1 {
        font-size: 22px;
        line-height: 1.3;
        word-break: break-word;
      }
    }

    .detail-top--right {
      width: 100%;
      flex: none;
      margin-left: 0;
    }

    .rooms {
      height: auto;
      display: flex;
      flex-wrap: wrap;
      gap: 8px 12px;
      line-height: 1.4;

      > span {
        margin-left: 0;
        padding-right: 0;
        border-right: 0;
      }
    }
  }

  .features {
    .title,
    .feature-list {
      display: block;
      width: 100%;
    }

    .feature-list {
      margin-top: 10px;

      .feature-item {
        margin: 0 12px 8px 0;
      }
    }
  }

  .video {
    .title {
      width: auto;
      padding-top: 24px;
      margin-bottom: 16px;
    }

    .youtube {
      position: relative;
      overflow: hidden;
      width: 100%;
      padding-top: 56.25%;
    }
  }

  .geo {
    margin-bottom: 32px;

    .geo-title {
      margin-bottom: 16px;
    }

    .geo-map,
    .geo-map-instance {
      height: 260px;
    }

    .geo--nearby--box {
      .geo--nearby--box--head {
        overflow-x: auto;
        white-space: nowrap;

        .geo--nearby--box--head--item {
          flex: 0 0 auto;
          margin-right: 24px;
        }
      }
    }
  }

  .public {
    .public-items ul li {
      width: 100%;
    }
  }

  .more-info {
    margin-top: 32px;

    .more-info-items label,
    .more-info-items label:nth-child(2n + 2) {
      width: 100%;
    }
  }

  .rate {
    padding: 16px;

    .rate-agent,
    .rate-user {
      display: block;
      width: 100%;
      margin-right: 0;
    }
  }

  .section-float {
    position: static;
    width: 100%;
    height: auto;
    padding-bottom: 24px;
    order: 2;
  }

  .detail-date {
    right: 10px;
    left: 10px;
    width: auto;
  }
}
</style>
